import * as Sentry from '@sentry/vue'
import Vue from 'vue'
import { isProduction, isPrerelease } from '@com/config/env.js'

export function sentryInit(options: { dsn: string }): void {
  if (isProduction || isPrerelease) {
    Sentry.init({
      Vue,
      dsn: options.dsn,
      environment: process.env.NODE_ENV,
      release: process.env.TAG,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      beforeSend(event) {
        event.tags = event.tags || {}
        event.tags.full_url = window.location.href

        return event
      },
    })
  }
}
